import React from "react";
import "./common.css";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function RainbowButton({ children, className }: Props) {
  return (
    <div className={['rainbow-button', className].filter(Boolean).join(' ')}>
      <span></span>
      {children}
    </div>
  );
}
